import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { ExclamationCircleIcon, XIcon } from '@heroicons/react/outline';

/**
 * ConfidentialDownloadDialog
 * --------------------------
 * The confidentiality warning every download in the triage application shows
 * before the file is prepared (TDI-484, pilot SOP A.10). One shared dialog,
 * used by the shared download hook and the letter downloads, never copied.
 *
 * Interim wording from the ticket; the final wording is Jasmine's call and
 * the visual is checked against Diana's frame before release (both flagged on
 * TDI-484) — update here only, every entry point follows.
 */
export const CONFIDENTIAL_DOWNLOAD_WARNING =
  'This file contains patient-confidential information. Handle it as NHS data '
  + 'and do not save it to a personal device.';

export default function ConfidentialDownloadDialog({ open, onOpenChange, onConfirm }) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="radix-dialog-overlay-motion fixed inset-0 bg-black/40 backdrop-blur-sm z-50" />
        <Dialog.Content className="radix-dialog-content-centered-motion fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90vw] max-w-md bg-white rounded-xl shadow-lg z-50 overflow-hidden">
          <div className="flex items-start justify-between p-5 pb-3">
            <div className="flex items-start gap-3 text-left">
              <ExclamationCircleIcon className="w-6 h-6 mt-0.5 flex-shrink-0 text-amber-600" aria-hidden="true" />
              <div>
                <Dialog.Title className="text-base font-semibold text-gray-900">
                  Patient-confidential download
                </Dialog.Title>
                <Dialog.Description className="text-sm text-gray-700 mt-1">
                  {CONFIDENTIAL_DOWNLOAD_WARNING}
                </Dialog.Description>
              </div>
            </div>
            <Dialog.Close asChild>
              <button
                type="button"
                className="p-1 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                aria-label="Close"
              >
                <XIcon className="w-5 h-5" />
              </button>
            </Dialog.Close>
          </div>
          <div className="flex justify-end gap-3 p-5 pt-2">
            <Dialog.Close asChild>
              <button
                type="button"
                className="px-4 py-2 text-sm font-medium rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
            </Dialog.Close>
            <button
              type="button"
              onClick={onConfirm}
              className="px-4 py-2 text-sm font-bold rounded-md bg-primary text-white hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-colors"
            >
              Continue
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
